export default "__VITE_ASSET__DfthbEwV__"